import { fromJS } from 'immutable'
import {
  COMPENSATE_REQUEST_CANCEL_REQUEST,
  COMPENSATE_REQUEST_CANCEL_SUCCESS,
  COMPENSATE_REQUEST_CANCEL_FAILURE,
  COMPENSATE_REQUEST_CANCEL_RESET,
} from '../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case COMPENSATE_REQUEST_CANCEL_REQUEST:
      return state
        .set('isFetching', true)
    case COMPENSATE_REQUEST_CANCEL_SUCCESS:
      return state
        .set('updatedCompensate', fromJS(action.payload.updatedCompensate))
        .set('status', 200)
        .set('message', 'Canceled Successfully.')
        .set('isFetching', false)
    case COMPENSATE_REQUEST_CANCEL_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('updatedCompensate', fromJS(action.payload.message))
        .set('status', fromJS(action.payload.message))
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case COMPENSATE_REQUEST_CANCEL_RESET:
      return state
        .delete('updatedCompensate')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/compensate-request/compensate-request-cancel-reducer.js